<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_3205_57106)">
<rect y="10.3" width="7.02698" height="1.7" rx="0.85" fill="currentColor"/>
<rect x="14.973" y="10.3" width="7.02698" height="1.7" rx="0.85" fill="currentColor"/>
<path d="M9.30011 7.23096L11.8192 10.4435C12.0603 10.7509 12.0603 11.2492 11.8192 11.5565L9.30011 14.7691" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>
</g>
<defs>
<clipPath id="clip0_3205_57106">
<rect width="22" height="22" fill="white"/>
</clipPath>
</defs>
</svg>
